import {
  createAndSendExternalInvitation,
  CreateAndSendExternalInvitationParams,
} from '@/domain/external-invitation/actions/create-and-send-external-invitation.action';
import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';
import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import { getExternalInvitationSurveys } from './get-external-invitation-surveys.action';
import { getSurveysResults } from './get-surveys-results.action';

export type CreateAndSendExternalInvitationSurveyParams = {
  eventPosition: PositionGeocode | undefined;
  title: string;
  projectId: number;
  scope: Scope;
};

export const createExternalInvitationSurvey = createAppAsyncThunk(
  'externalInvitationSurvey/createExternalInvitationSurvey',
  async (
    params: CreateAndSendExternalInvitationSurveyParams,
    { dispatch },
  ): Promise<void> => {
    const arg: CreateAndSendExternalInvitationParams = {
      projectId: params.projectId,
      name: '',
      email: '',
      limitDate: '',
      eventPosition: params.eventPosition,
      title: params.title,
      sector: 'ANY',
      scope: params.scope,
    };
    await dispatch(createAndSendExternalInvitation(arg));
    await dispatch(getExternalInvitationSurveys());
    await dispatch(getSurveysResults());
  },
);
